import { localStorageCache } from "core/store";
const PHRASE_LIST_KEY = "phraseList";

export class PhraseService {
    constructor(baseUrl, apiClient) {
        this.apiClient = apiClient;
        this.baseUrl = baseUrl;
        this.phrases = [];
        this.loadingPromise = null;
    }

    async fetchFromApi() {
        const url = `${this.baseUrl}/phrase/active`;
        const response = await this.apiClient.get(url);
        return response.data;
    }

    async load() {
        if (this.loadingPromise) {
            return this.loadingPromise;
        }

        this.loadingPromise = (async () => {
            const cached = localStorageCache.getItem(PHRASE_LIST_KEY);

            if (cached) {
                try {
                    const parsed = JSON.parse(cached);
                    if (Array.isArray(parsed)) {
                        this.phrases = parsed;
                        return this.phrases;
                    }
                } catch {
                    localStorageCache.removeItem(PHRASE_LIST_KEY);
                }
            }

            const result = await this.fetchFromApi();

            if (Array.isArray(result)) {
                localStorageCache.setItem(
                    PHRASE_LIST_KEY,
                    JSON.stringify(result)
                );
                this.phrases = result;
            }

            return this.phrases;
        })();

        return this.loadingPromise;
    }

    get() {
        return this.phrases;
    }

    async refresh() {
        localStorageCache.removeItem(PHRASE_LIST_KEY);
        this.loadingPromise = null;
        return this.load();
    }
}
